import { render, staticRenderFns } from "./BackgroundChecks.vue?vue&type=template&id=186dc3ae"
import script from "./BackgroundChecks.vue?vue&type=script&lang=ts"
export * from "./BackgroundChecks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports